import React from 'react';

export const Homepage = React.lazy(() => import('../components/newhomepage'));

export const LOGIN = React.lazy(() => import('../components/loginpage'));

export const SIGNUP = React.lazy(() => import('../components/signup'));

export const DISCOVER = React.lazy(() => import('../components/discover'));

export const ADDTOCART = React.lazy(() => import('../components/addToCart'));

export const CHECKOUT = React.lazy(() => import('../components/checkout'));

export const ADDRESSE = React.lazy(() => import('../components/addresse'));

export const PRODUCT_DETAILS = React.lazy(() => import('../components/detailsproduct'));

export const DETAILS = React.lazy(() => import('../components/details'));

export const PROFILE = React.lazy(() => import('../components/profile'));

export const USER_PROFILE = React.lazy(() => import('../components/userProfile'));

export const USER_PRODUCTS = React.lazy(() => import('../components/products'));

export const RETURN_AND_REFUND = React.lazy(() => import('../components/ReturnandRefund'));

export const STYLES = React.lazy(() => import('../components/styles'));

export const MY_ACCOUNT = React.lazy(() => import('../components/account'));

export const MY_ADDRESS = React.lazy(() => import('../components/myaddress'));

export const CHANGE_PASSWORD = React.lazy(() => import('../components/changepassword'));

export const FORGOT_PASSWORD = React.lazy(() => import('../components/forgotPassword'));

export const NOTIFY = React.lazy(() => import('../components/notification'));

export const MY_CART = React.lazy(() => import('../components/cart'));

export const DISCOVER_DETAILS = React.lazy(() => import('../components/discoverdetails'));